var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02333 7.99167C2.9425 7.45083 2.27333 6.89167 2.27333 6.02083C2.27333 5.02167 3.19917 4.325 4.74833 4.325C6.38 4.325 6.985 5.10417 7.04 6.25H9.06583C9.00167 4.67333 8.03917 3.225 6.12333 2.7575V0.75H3.37333V2.73C1.595 3.115 0.165 4.27 0.165 6.03917C0.165 8.15667 1.91583 9.21083 4.47333 9.825C6.765 10.375 7.22333 11.1817 7.22333 12.0342C7.22333 12.6667 6.77417 13.675 4.74833 13.675C2.86 13.675 2.1175 12.8317 2.01667 11.75H0C0.11 13.7575 1.61333 14.885 3.37333 15.2608V17.25H6.12333V15.2792C7.91083 14.94 9.33167 13.9042 9.33167 12.025C9.33167 9.42167 7.10417 8.5325 5.02333 7.99167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/$.e6ee760bc4062fd14c0ad29926a46db2.svg";
export { ForwardRef as ReactComponent };